import { TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { FONT, getFont } from '@tornado-rdk/typography';
import { safetyMargins, FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../../../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const CONTENT_SIDE_MARGIN = {
  [HD]: 152,
  [FULL_HD]: 232,
};

export const BUTTON_MARGIN_RIGHT = {
  [HD]: 24,
  [FULL_HD]: 24,
};

export const PADDING_BOTTOM = {
  [HD]: safetyMargins.vertical[HD],
  [FULL_HD]: safetyMargins.vertical[FULL_HD],
};

export const PADDING_TOP = {
  [HD]: 32,
  [FULL_HD]: 48,
};

export const DESCRIPTION_PADDING_BOTTOM = {
  [HD]: 32,
  [FULL_HD]: 48,
};

export const colors = {
  background: makeThemeColor(TERTIARY),
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const descriptionFont = getFont(FONT.OTTAWA_1, screenSize);
  const wordWrapWidth = SCREEN_WIDTH[screenSize] - CONTENT_SIDE_MARGIN[screenSize] * 2;

  return {
    rect: true,
    w: SCREEN_WIDTH[screenSize],
    mountY: 1,
    y: SCREEN_HEIGHT[screenSize],
    x: 0,
    color: colors.background[colorMode],
    flex: { direction: 'column', paddingBottom: PADDING_BOTTOM[screenSize] },
    Description: {
      flexItem: { marginBottom: DESCRIPTION_PADDING_BOTTOM[screenSize] },
      x: CONTENT_SIDE_MARGIN[screenSize],
      y: PADDING_TOP[screenSize],
      text: {
        textAlign: 'center',
        wordWrapWidth,
        ...descriptionFont,
      },
    },
    ButtonsRow: {
      flex: { direction: 'row', justifyContent: 'center' },
      flexItem: { marginTop: DESCRIPTION_PADDING_BOTTOM[screenSize] },
      AcceptAll: {
        flexItem: { marginRight: BUTTON_MARGIN_RIGHT[screenSize] },
      },
      Settings: {
        flexItem: { marginRight: BUTTON_MARGIN_RIGHT[screenSize] },
      },
    },
  };
};
